import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import axios from 'axios';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ToastContext } from 'app/context/ToastContext';
import { SortOrder } from 'primereact/api';

const Stornofond = () => {
  const { showSuccess, showError } = useContext(ToastContext); // Use the context for toast
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingRows, setEditingRows] = useState({});

  useEffect(() => {
    axios
      .get(`/api/stornofond`)
      .then(response => {
        setData(response.data);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => setLoading(false));
  }, []);

  const onAddInterval = () => {
    const newRow = { id: 0 - data.length };
    setData([...data, newRow]);
  };

  const onRowEditInit = event => {
    const { index } = event;
    setEditingRows(prev => ({ ...prev, [index]: { ...data[index] } }));
  };

  const onRowEditCancel = event => {
    const { index } = event;
    setEditingRows(prev => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };

  const removeRow = rowId => {
    const updatedData = data.filter(row => row.id !== rowId);
    setData(updatedData);
  };

  const deleteButtonTemplate = rowData => {
    return (
      <Button
        style={{ backgroundColor: '#e31818' }}
        icon="pi pi-trash"
        className="p-button-danger p-button-sm"
        onClick={() => removeRow(rowData.id)}
      />
    );
  };

  const updateData = () => {
    setLoading(true);
    axios
      .put(`/api/stornofond`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        setData(response.data);
        showSuccess('Úspech', 'Stornofond uložený');
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const onSaveProducts = () => {
    setTimeout(() => {
      updateData();
    }, 100);
  };

  const onCellEditComplete = e => {
    const { rowData, newValue, field, originalEvent: event } = e;

    rowData[field] = newValue;

    // const updatedProducts = [...data];
    // updatedProducts[event.rowIndex][event.field] = event.newValue;
    //
    // console.log('event', updatedProducts);
    // setEditingRows(updatedProducts);
  };

  // Editor for quantity, vat, and price fields (numeric)
  const inputNumberEditor = options => {
    return (
      <InputNumber
        value={options.value}
        locale="sk"
        minFractionDigits={0}
        maxFractionDigits={2}
        onValueChange={e => options.editorCallback(e.value)}
        className="w-full"
      />
    );
  };

  if (loading) {
    return (
      <div className="center-spinner">
        <ProgressSpinner />
      </div>
    );
  }

  const valueTemplate = (rowData, a) => {
    // console.log('rowe', , a);
    // return rowData.fromPersistence;

    const value = rowData[a.field];

    if (value === null || value === undefined) return '';
    return new Intl.NumberFormat('sk-SK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  };

  return (
    <>
      <h3>Výška stornofondu</h3>
      <div className="grid m-2">
        <div className="col-12">
          {data && (
            <DataTable
              stripedRows
              value={data}
              sortField="fromPersistence"
              sortOrder={SortOrder.DESC}
              loading={loading}
              dataKey="id"
              editMode="cell"
              className="p-datatable-sm"
            >
              <Column
                field="fromPersistence"
                header="Od perzistencie"
                editor={options => inputNumberEditor(options)}
                onCellEditComplete={onCellEditComplete}
                body={valueTemplate}
                style={{ width: '150px' }}
              />

              <Column
                field="toPersistence"
                header="Do perzistencie"
                editor={options => inputNumberEditor(options)}
                onCellEditComplete={onCellEditComplete}
                body={valueTemplate}
                style={{ width: '150px' }}
              />

              <Column
                field="stornofondValue"
                header="Odvod do stornofondu (%)"
                editor={options => inputNumberEditor(options)}
                onCellEditComplete={onCellEditComplete}
                body={valueTemplate}
                style={{ width: '150px' }}
              />
              <Column body={deleteButtonTemplate} header="Akcie" style={{ width: '10%', textAlign: 'center' }} />
            </DataTable>
          )}
        </div>

        <div className="col-6">
          <Button disabled={loading} type="button" label="Pridať nový interval" onClick={onAddInterval} className="p-button-info w-full" />
        </div>
        <div className="col-6">
          <Button
            disabled={loading}
            type="button"
            label="Uložiť odvody do stornofondu"
            onClick={onSaveProducts}
            className="p-button-success w-full"
          />
        </div>
      </div>
    </>
  );
};

export default Stornofond;
